import {React ,useContext} from 'react'
import Cards from "../Content/Cards"
import "../Pages/Trending_sty.css"
import { GlobalContext } from "../Context/GlobalState";


const FavMovs = () => {
  const {fav_movies} = useContext(GlobalContext);
  return (
    <>
    <span className = "pagetitle">Favourite</span>
     <div className = "Trend">{fav_movies&&fav_movies.map((val)=>{
       return(
       <Cards 
       key = {val.id} 
       id = {val.id} 
       poster = {val.poster_path} 
       title = {val.title || val.name} 
       date = {val.release_date || val.first_air_date}
       media_type = {val.type ? "tv":"movie"}
       vote_average = {val.vote_average}
       />
       )
       })}</div> 
    </>
  )
}

export default FavMovs
